import { render, staticRenderFns } from "./TVUnresolvedInquiries.vue?vue&type=template&id=6208b3c7&scoped=true&"
import script from "./TVUnresolvedInquiries.vue?vue&type=script&lang=js&"
export * from "./TVUnresolvedInquiries.vue?vue&type=script&lang=js&"
import style0 from "./TVUnresolvedInquiries.vue?vue&type=style&index=0&id=6208b3c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208b3c7",
  null
  
)

export default component.exports